export const BENEFITS_INSURANCE_TABS = [
  "all",
  "independent-contractor",
  "personal"
] as const;

export type BenefitsInsuranceTab = (typeof BENEFITS_INSURANCE_TABS)[number];
